<template>
    <record-choose-item
        v-bind:recordData="source"
        v-bind:itemFunc="chooseGetRecordItem">
    </record-choose-item>
</template>

<script>
import { UTILS } from '../../modules/utils';
import RecordChooseItem from '../record/RecordChooseItem.vue'
export default {
    name: 'GetChooseItem',
    components: { RecordChooseItem },
    props: {
        source: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        chooseGetRecordItem(data){
            var curShareSelectList = this.$store.state.record.curShareSelectList,
                curIndex = UTILS.getIdIndexInObjectArray(curShareSelectList, data.id);
            if(curIndex == -1) {
                this.$store.state.record.curShareSelectList.push(data);
            }else {
                this.$store.state.record.curShareSelectList.splice(curIndex, 1);
            }
        },
    }
}
</script>